import $ from 'jquery';
import Swiper from 'swiper';

function get_unique_array(array) {
  var newArray = new Array();
  var handleArray = new Array();

  for (var i = 0; i < array.length; i++) {
    var handle = array[i]['handle'];
    if (handleArray.indexOf(handle) === -1) {
      newArray.push(array[i]);
      handleArray.push(handle);
    }
  }
  return newArray;
}

export default class RecentlyViewed {
  RECENTLY_VIEWED_COUNT = 10;
  RECENTLY_VIEWED_LOCAL_STORAGE_KEY = 'recentlyVisited';
  PLACEHOLDER = 'PLACEHOLDER';

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;

    this.$element = $(element);
    this.handle = this.element.dataset.productHandle;
    this.productUrl = this.element.dataset.productUrl;
    this.$content = this.$element.find('#recently-viewed-products');
    if (this.$content.hasClass('recently-viewed-loading')) {
      return;
    }

    this.$content.empty().removeClass('owl-carousel owl-theme owl-loaded owl-drag').addClass('recently-viewed-loading');

    var recentlyViewedJSON = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY);
    var recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];

    if (this.handle) {
      var item = {
        'handle': this.handle,
      };
      recentlyViewed.unshift(item);
    }

    var uniqueArray = recentlyViewed.length ? get_unique_array(recentlyViewed) : recentlyViewed;
    if (uniqueArray.length > this.RECENTLY_VIEWED_COUNT) {
      uniqueArray = uniqueArray.slice(0, this.RECENTLY_VIEWED_COUNT);
    }

    localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));

    if (uniqueArray.length > 1 || (uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle)) {
      this.loadProducts(uniqueArray.filter((item) => { return item.handle !== this.handle }));
    } else {
      this.$element.remove();
    }
  }

  loadProducts = (recentlyViewed) => {
    var promises = recentlyViewed.map(function (rv) {
      return $.get(this.productUrl.replace(this.PLACEHOLDER, rv.handle));
    }.bind(this));
    $.when.apply($, promises)
      .then(() => {
        let allOK = true;
        promises.forEach((promise) => {
          if (promise.status === 200) {
            var container = document.createElement("div");
            container.innerHTML = promise.responseText;
            this.$content.append(container.querySelector(".main-content .grid__item").outerHTML);
            this.$content.find('.grid__item').addClass('swiper-slide');
          } else {
            console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
            allOK = false;
          }
        });
        if (allOK) {
          this.show();
        }
        else {
          this.hideButtons();
        }
      });
  }

  hideButtons = () => {
    this.$element.find('.swiper-button--next').hide();
    this.$element.find('.swiper-button--prev').hide();
  }

  show = () => {
    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    this.$element.fadeIn();
    this.swiper = new Swiper(this.element.querySelector('.swiper-container'), {
      slidesPerView: 2,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        600: {
          slidesPerView: 4,
        },
      },
      watchOverflow: true,
      autoHeight: true,
    });

    this.loadShopNow();
    this.loadReviews();
    this.badge = this.theme.addBadges(this.element, 1000);
  }

  loadShopNow = () => {
    if (this.element.dataset.quickShop === 'true') {
      // it was not added in liquid as we cannot access this section settings, we have to add it manually
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.grid-view-item'),
        (el) => {
          const title = el.querySelector('.product-grid--title');

          const a = document.createElement('a');
          a.classList.add('shop-now-button');
          a.href = title.querySelector('a').href;
          a.textContent = this.theme.translations.quick_shop;
          a.addEventListener('click', this.handleShopNow);

          const wrapper = document.createElement('div');
          wrapper.classList.add('shop-now-wrapper');
          wrapper.appendChild(a);

          title.parentNode.insertBefore(wrapper, title);
        }
      )
    }
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.target.href });
  }

  loadReviews = () => {
    if (this.element.dataset.showReviews === 'true') {
      // it was not added in liquid as we cannot access this section settings, we have to add it manually
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.product-grid--price a'),
        (el) => {
          const badge = document.createElement('span');
          badge.classList.add('shopify-product-reviews-badge');
          badge.dataset.id = el.dataset.productId;
          el.appendChild(badge);
        },
      );
      this.theme.loadReviews({ badges: true });
    }
  }
}
